import * as SwitchPrimitive from "@radix-ui/react-switch";
import { forwardRef, type ComponentPropsWithoutRef } from "react";
import { cn } from "@/shared/lib/utils";

/**
 * Radix Switch wrapper for binary on/off chrome (e.g. the Collect page publish
 * toggle). Pill track with a sliding thumb: glass-subtle when off, brand fill
 * when on. Semantic tokens only; brand focus ring matching the other controls.
 */
export const Switch = forwardRef<
  HTMLButtonElement,
  ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(function Switch({ className, ...props }, ref) {
  return (
    <SwitchPrimitive.Root
      ref={ref}
      className={cn(
        "inline-flex h-6 w-11 shrink-0 items-center rounded-full border border-border",
        "glass-surface-subtle transition-colors duration-150",
        "data-[state=checked]:bg-brand data-[state=checked]:border-brand",
        "disabled:opacity-50 disabled:pointer-events-none",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          "pointer-events-none block h-5 w-5 translate-x-0.5 rounded-full bg-surface",
          "transition-transform duration-150",
          "data-[state=checked]:translate-x-[1.375rem]",
        )}
      />
    </SwitchPrimitive.Root>
  );
});
